import Ribbon from './Ribbon';
export default Ribbon;